<app-header></app-header>

<div class="custom_scrollbar">
  <div>
    <section
      class="pt-5 d-table w-100"
      style="background: linear-gradient(180deg, #96c2dd, #ffffff 90%)"
    >
      <div class="container">
        <div
          class="row mt-5 align-items-center position-relative"
          style="z-index: 1; bottom: 5rem"
        >
          <div class="col-lg-6">
            <span class="badge bg-primary-subtle text-primary mb-3">
              <i class="bi bi-car-front"></i> Auto Business
            </span>
            <div class="title-heading text-center text-lg-start">
              <h1
                class="fw-bold mb-3 mt-3"
                style="color: #242335; font-size: 2rem; line-height: 1.4"
              >
                Transform Your Auto Business with ConnectNow
              </h1>
              <p
                class="para-desc mx-auto mx-lg-start mb-0 ms-0"
                style="color: black"
              >
                In today’s fast-paced world, timing is everything. Imagine a
                showroom that is open <b>365 days a year, 24 hours a day</b>.
                With <strong>ConnectNow</strong>F, you can provide 24/7
                availability to your customers, ensuring that they never miss an
                opportunity to explore, inquire, or purchase vehicles—no matter
                the time or day.
                <br />
                <br />
                <strong>ConnectNow</strong> introduces
                <b>a new way of buying and selling cars, powered by AI</b>,
                while still maintaining the <b>personal human touch</b>. This
                innovative approach allows you to engage customers seamlessly,
                keeping them connected and informed at every step, ensuring no
                sales opportunity slips away.
              </p>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-6 mt-4 pt-2 mt-lg-0 pt-lg-0">
            <div class="card border-0 shadow rounded ms-lg-4 overflow-hidden">
              <iframe
                class="iframe w-100 rounded"
                width="560"
                height="315"
                src="https://www.youtube-nocookie.com/embed/e1OnUbxnHiw?si=-dnf1VonvC-aa_6v&amp;controls=1&rel=0&loop=1"
                title="YouTube video player"
                frameborder="0"
                allow="
                  accelerometer;
                  autoplay;
                  clipboard-write;
                  encrypted-media;
                  gyroscope;
                  picture-in-picture;
                  web-share;
                "
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>

    <section class="pt-5 d-table w-100">
      <div class="container feature">
        <div
          class="row align-items-center position-relative"
          style="z-index: 1; bottom: 5rem"
        >
          <div class="col-lg-6 pe-lg-5 mt-5">
            <h4><b>Driving the Future of Vehicle Sales</b></h4>
            <div class="d-flex justify-content-between align-items-center mt-5">
              <div class="feature_graphic">
                <img src="assets/bot.webp" alt="bot_image" />
              </div>
              <div class="mx-2">
                <h5>24x7 Availability</h5>
                <p>
                  Round-the-Clock Assistance for Every Customer. Never Miss a
                  Sales Opportunity
                </p>
              </div>
            </div>
            <div
              class="d-flex flex-row-reverse justify-content-between align-items-center mt-5"
            >
              <div class="feature_graphic">
                <img
                  src="assets/real_time_sales_assistant.webp"
                  alt="Real time sales assistance"
                />
              </div>
              <div class="mx-2">
                <h5>Real time sales assistance</h5>
                <p>
                  AI assisted inventory look up. Connect with a real agent when
                  ready
                </p>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-5">
              <div class="feature_graphic">
                <img
                  src="assets/view_car.webp"
                  alt="View your car from living room"
                />
              </div>
              <div class="mx-2">
                <h5>View your car from living room</h5>
                <p>
                  Explore Your Dream Car with Live Video Calls with Expert Sales
                  Representatives
                </p>
              </div>
            </div>
            <div
              class="d-flex flex-row-reverse justify-content-between align-items-center mt-5"
            >
              <div class="feature_graphic">
                <img src="assets/schedule.webp" alt="Schedule sales visit" />
              </div>
              <div class="mx-2">
                <h5>Schedule sales visit</h5>
                <p>Book testdrives or showroom visits in seconds</p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 ps-lg-5 mt-5">
            <h4><b>On-Demand Vehicle Care – 24/7 Assistance</b></h4>
            <div class="d-flex justify-content-between align-items-center mt-5">
              <div class="feature_graphic">
                <img src="assets/booking.webp" alt="24x7 service booking" />
              </div>
              <div class="mx-2">
                <h5>24x7 service booking</h5>
                <p>
                  Schedule repairs and maintenance anytime through connectnow
                </p>
              </div>
            </div>
            <div
              class="d-flex flex-row-reverse justify-content-between align-items-center mt-5"
            >
              <div class="feature_graphic">
                <img
                  src="assets/car_diagnostics.webp"
                  alt="AI powered diagnostics"
                />
              </div>
              <div class="mx-2">
                <h5>AI powered diagnostics</h5>
                <p>
                  Instantly assess issues and get service suggestions based on
                  your inputs, saving time and avoiding guess work
                </p>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-5">
              <div class="feature_graphic">
                <img
                  src="assets/realtime_support.webp"
                  alt="Real-time service support"
                />
              </div>
              <div class="mx-2">
                <h5>Real-time service support</h5>
                <p>
                  Connect Live with a Service Expert via Video or Audio Calls
                  Anytime as needed
                </p>
              </div>
            </div>
            <div
              class="d-flex flex-row-reverse justify-content-between align-items-center mt-5"
            >
              <div class="feature_graphic">
                <img
                  src="assets/schedule_service_visit.webp"
                  alt="Schedule service visits"
                />
              </div>
              <div class="mx-2">
                <h5>Schedule service visits</h5>
                <p>
                  Arrange service appointments and receive automated reminders
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <app-footer></app-footer>
  <div class="fix-ui">
    <app-fixed-call></app-fixed-call>
  </div>
</div>
